import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { StoreRouterConnectingModule } from "@ngrx/router-store";

export const environmentSpecificModules = [
  StoreDevtoolsModule.instrument({
    name: "RiPSIM NgRx Devtools",
    maxAge: 100,
    logOnly: false,
    features: {
      pause: false,
      lock: false,
      persist: false,
      export: false,
      jump: false,
      skip: false,
      reorder: false,
      dispatch: false,
      test: false,
    },
  connectInZone: true}),
  StoreRouterConnectingModule.forRoot(),
];
